export default __webpack_public_path__ + "static/5-a7dec282b5f9040b3eedaf11a26b754d.jpeg";